import axios from "axios";
import { ChangelogFeature, ChangelogResponse } from "@/api/types";

export const getChangelogs = () => axios.get<ChangelogResponse>('changelog');
export const getPublicChangelogs = () => axios.get<ChangelogResponse>('changelog/public');
export const deleteLog = (id: number) => axios.delete(`changelog/${ id }`);
export const createChangelog = (version: string, type: string, beta: boolean, features: Array<ChangelogFeature>) =>
    axios.post('changelog/create', { version, type, beta, features });
export const appendSilentPatch = (type: string, beta: boolean, features: Array<ChangelogFeature>) =>
    axios.post<{ id: number; version: string }>('changelog/silent', { type, beta, features });
